import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { Address } from '@app/interfaces/address';
import { PdvService } from '@app/services/pdv/pdv.service';
import { OrdersService } from '@app/services/order/orders.service';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';

@Component({

    selector: 'confirmation',
    templateUrl: 'confirmation.component.html',
    styleUrls: ['confirmation.component.scss']
})

export class ConfirmationComponent {
    loader: boolean = false;
    order: any;
    orderTypes: any[] = [];
    chosenOrderType: number;
    orderTypeLabel: string;
    orderErreurModePaimenet = false;
    orderProg: Date;
    payementModes: Array<any> = [];
    address: Address;
    subscriptions: Subscription[] = [];
    enablePayement = false;
    coupon = "";
    couponAdded = false;
    constructor(
        private pdvService: PdvService,
        private toastr: ToastrService,
        private orderService: OrdersService,
        private webSiteUsersService: WebSiteUsersService,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {
        let subs1 = this.orderService.order.subscribe(
            (order) => {
                this.order = order;
                order.payamentmode = null;
            }
        )
        let subs2 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
            this.orderTypes = orderTypes;
            if (this.orderTypes.length > 0 && this.chosenOrderType > 0) {
                this.orderTypeLabel = this.orderTypes.filter(o => o.id == this.chosenOrderType)[0].label
            }
        });
        let subs3 = this.orderService.address.subscribe((address: Address) => {
            this.address = address;
        });
        let subs5 = this.orderService.orderProg.subscribe((orderProg: Date) => {
            this.orderProg = orderProg;
        });
        let subs6 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.orderTypes.length > 0 && this.chosenOrderType > 0) {
                this.orderTypeLabel = this.orderTypes.filter(o => o.id == this.chosenOrderType)[0].label
                this.getPdvMode();
            }
        });
        let subs7 = this.orderService.enablePayement.subscribe(
            (enablePayement) => {
                this.enablePayement = enablePayement
                if (!this.enablePayement) {
                    this.order.payamentmode = 2;
                }
                console.log(this.order.payamentmode, this.enablePayement)
            }
        );
        this.subscriptions.push(subs1, subs2, subs3, subs5, subs6);
    }
    getPdvMode() {
        this.pdvService.getPaymentModes(this.chosenOrderType).subscribe(
            (data: any[]) => {
                this.payementModes = data;
            }
        )
    }
    save() {
        if (this.order.payamentmode == 1 || this.order.payamentmode == 2) {
            if (this.order.payamentmode == 1) {
                this.order.payementModes = [{ id: 2, text: "CB" }];
                this.setOrder();
            } else {
                if (this.order.elements.length > 0 || this.order.menus.length > 0) {
                    this.order.payementModes = this.payementModes.filter(p => p.checked).map(p => ({ id: p.id, label: p.text }));
                    if (!this.order.payementModes || this.order.payementModes.length == 0) {
                        this.toastr.error('Sélectionnez un mode de réglement', 'Attention !');
                    } else {
                        this.setOrder();
                    }
                } else {
                    this.toastr.error('Votre panier est vide! merci de choisir un produit', 'Attention !');
                }
            }
        } else {
            this.toastr.error('Choisissez un mode de paiement', 'Attention !');
        }
    }
    setOrder() {
        this.order.user = '0';
        this.order.orderType = this.chosenOrderType;
        this.order.pdv = this.pdvService.idPdv;
        this.order.orderProg = this.orderProg.toString();
        if (this.chosenOrderType == 1) {
            if (this.address.id) {
                this.webSiteUsersService.updateAddress(this.address).subscribe(
                    (da: any) => {
                        this.order.idAddress = this.address.id;
                        this.addOrder();
                    }, err => {
                        this.alertMessage(err)
                    }
                )
            } else {
                this.webSiteUsersService.addAddress(this.address).subscribe(
                    (da: any) => {
                        this.order.idAddress = da.id;
                        this.addOrder();
                    }, err => {
                        this.alertMessage(err)
                    }
                )
            }
        } else {
            this.addOrder();
        }
    }

    alertMessage(err) {
        let message = 'Erreur de serveur';
        if (err.error.message) {
            message = err.error.message;
        }
        this.toastr.error(message, "Erreur");
        this.loader = false;
    }

    addOrder() {
        if (this.order.payamentmode == 1) {
            let amount = this.order.total;
            this.webSiteUsersService.getPayerId().subscribe(
                (payerId) => {
                    this.orderService.getPayementData({ amount, payerId }).subscribe(
                        (data: any) => {
                            this.validOrder(data.id, data.redirect_url);
                        }
                    )
                }, err => {
                    this.alertMessage(err)
                }

            )
        } else {
            this.validOrder();
        }
    }

    validOrder(transactionId = '', redirect_url = '') {
        setTimeout(
            () => {
                this.loader = true;
                this.order.transactionId = transactionId;
                this.orderService.addOrder(this.order).subscribe(
                    (data: any) => {
                        this.loader = false;
                        if (data.success) {
                            let payamentmode = JSON.parse(JSON.stringify(this.order.payamentmode));
                            if (payamentmode == 2) {
                                this.orderService.clearOrder();
                                this.orderService.chosenOrderType.next(0);
                                this.orderService.address.next({
                                    id: null,
                                    address: "",
                                    city: "",
                                    postalCode: null,
                                    streetNumber: null,
                                    streetName: "",
                                });
                                this.router.navigate(['/commandes']);
                            } else {
                                if (isPlatformBrowser(this.platformId)) {
                                    window.location.href = redirect_url;
                                }
                            }
                        } else {
                            if (data.code == 2) {
                                let sub = this.pdvService.pdv.subscribe(
                                    (data) => {
                                        data.closeSite = true;
                                        this.toastr.error(data.closeComment, 'Attention!');
                                        this.pdvService.pdv.subscribe(data);
                                    }
                                )
                                sub.unsubscribe();
                            }
                            if (data.code == 3) {
                                this.toastr.error('Merci de consulter votre boite email pour valider votre inscription.', 'Validation de compte!');
                            }
                            if (data.code == 4) {
                                this.toastr.error('Votre compte a été désactivé par le restaurateur', 'Login');
                            }
                        }
                    },
                    (err) => {
                        this.alertMessage(err)
                    }
                )
            }, 100
        )
    }

    ngOnDestroy() {
        this.unsubscribe();
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }

    addCoupon() {
        if (!this.couponAdded) {
            if (!this.coupon) {
                this.toastr.error('Veuillez insérer votre code promo', 'Erreur')
            } else {
                this.orderService.checkCoupon(this.coupon).subscribe(
                    (data) => {
                        this.couponAdded = true;
                        this.orderService.addCoupon(data);
                    },
                    (err) => {
                        this.alertMessage(err)
                    }
                )
            }
        }
    }

    removeCoupon() {
        this.orderService.removeCoupon();
        this.couponAdded = false;
        this.coupon = "";
    }

}
